/**
 * Renders the form to create or edit a top-level note
 */

import Backbone from 'backbone'

import template from './note-form.hbs'
import PeriodDisplay from 'scoreboard/components/period-display'
import CalendarPeriodSelector from 'scoreboard/components/calendar-period-selector'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import appDisplay from 'scoreboard/components/app-display'
import DateDisplay from './date-display'
import Tooltip from 'scoreboard/components/tooltip'
import calendars from 'scoreboard/components/calendars'
import globals from 'scoreboard/components/globals'
import htmlToText from 'scoreboard/components/html-to-text'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import notBlankValidator from 'scoreboard/components/validators/not-blank-validator'
import TextArea from 'scoreboard/components/textarea'

var NotePeriodSelector = CalendarPeriodSelector.extend({

	initialize: function(options) {
		this.periodId = options.periodId
		this.confirm = true // Add confirmation button
		this.backToDefaultButton = false // Don't add the back-to-default button

		// can't call PeriodSelector.prototype.render.apply(this,
		// arguments) because that method calls renderCalendar, and when
		// renderCalendar is called it will use the PeriodSelector
		// version instead of the NotePeriodSelectorVersion because
		// JavaScript doesn't have real inheritance
		this.once('show', function() {
			var allOption = new Option(i18n.get('common.allTime'))
			this.$('select.calendar').prepend(allOption).change(function(e) {
				// period and year should be hidden when all time is chosen, and
				// shown otherwise
				this.$('.period-selector, .year').toggle(!this.isAllTime(e))
			}.bind(this))
			// show "All Time" in the dropdown if appropriate
			if (this.periodId == null) {
				this.$('.calendar').prop('selectedIndex', 0).change()
				this.$('.period-selector, .year').toggle(false)
			}

			this.$('.button-primary').text(i18n.get('common.confirm'))
		}.bind(this))
	},

	isAllTime: function(e) {
		// this line copied from CalendarPeriodSelector.renderCalendar
		var id = _.isNumber(e) ? e : this.$('select.calendar').val()
		return isNaN(parseInt(id))
	},

	renderCalendar: function(e) {
		let isAllTime = this.isAllTime(e)
		this.$('.button-primary').removeClass('is-disabled', isAllTime)
		if (e != null && !isAllTime) {
			CalendarPeriodSelector.prototype.renderCalendar.apply(this, arguments)
		}
		// period and year should be hidden when all time is chosen, and
		// shown otherwise
		this.periodSelector && this.periodSelector.toggle(!isAllTime)
	},

	submit: function(e) {
		var periodId = this.isAllTime(e) ? null : this.periodSelector.val()
		this.trigger('change:period', periodId)
	}

})

var NotePeriodDisplay = PeriodDisplay.extend({

	selectorView: NotePeriodSelector,

	update: function(periodId) {
		if (periodId) {
			PeriodDisplay.prototype.update.apply(this, arguments)
		}
		else {
			this.$('.dropdown a .text').text(i18n.get('common.allTime'))
		}
		this.$('.backward, .forward').toggle(!!periodId)
	}

})

var NoteForm = Backbone.View.extend({

	// this.model is a new or existing top-level Note

	// this.options.defaultTime is the default time for the period selector when
	// creating a new note.  it's either a periodId for scorecards, or a date
	// for initiatives

	tagName: 'form',

	className: 'note-form',

	events: {
		'click .delete': 'delete',
		'click .period-display': 'clickPeriodDisplay'
	},

	initialize: function(options) {
		this.options = options
		this.domainObject = options && options.domainObject
		if (this.domainObject.section === 'scorecards') {
			var defaultTime = this.options.defaultTime || globals.periodId
			// #8386 for existing notes if the period is supposed to be "All
			// Time" it will come through as undefined, but we need to pass in
			// null to the period display to make "All Time" display
			var existingPeriodId = this.model.get('periodId') || null
			this.periodDisplay = new NotePeriodDisplay({
				periodId: this.model.isNew() ? defaultTime : existingPeriodId
			})
		}
		if (this.domainObject.section === 'initiatives') {
			this.dateDisplay = new DateDisplay({
				appliesTo: this.model.isNew() ? this.options.defaultTime : this.model.get('appliesTo')
			})
		}

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: true
		})
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.$('.delete').toggleClass('is-not-displayed', this.model.isNew())
		if (this.domainObject.section === 'scorecards') {
			this.$('.period-display').empty().append(this.periodDisplay.el)
			this.periodDisplay.render()
		}
		if (this.domainObject.section === 'initiatives') {
			this.$('.period-display').empty().append(this.dateDisplay.el)
			this.dateDisplay.render()
		}
		if (!this.model.isNew()) {
			this.$('h1').text(i18n.get('scorecards.notes.editNote'))
			this.$('.button-primary').text(i18n.get('common.save'))
		}
		this.textareaField = new MarkedField({
			el: this.$('textarea'),
			validators: [notBlankValidator]
		}).render()
		this.secure()
		this.formView.start()
		this.textArea = new TextArea({el: this.$('textarea')}).render()
		return this
	},

	context: function() {
		var context = _.cloneDeep(this.model.attributes)
		if (this.model.get('html')) {
			context.text = htmlToText(context.text)
		}
		return context
	},

	secure: function() {
		if (this.domainObject.section === 'scorecards') {
			if (!this.options.domainObject.get('createPeriodNotes')) {
				// set the selector to all time
				this.periodDisplay.refresh()
				this.periodDisplay.disable()
			}
		}
	},

	// displays a tooltip about why only general notes can be created, if
	// appropriate.  otherwise, this.periodDisplay will display a period
	// selector
	clickPeriodDisplay: function() {
		_.result(this.tooltip, 'remove')
		if (!this.options.domainObject.get('createPeriodNotes') &&
				this.domainObject.section === 'scorecards') {
			this.tooltip = new Tooltip({
				attachTo: this.$('.period-display'),
				attachToCenter: false,
				content: this.buildNotesLockedMessage(globals.periodId),
				placement: 'below',
				arrow: 'right',
				adjustment: 24 // Align with button arrow
			}).render()
		}
	},

	buildNotesLockedMessage: function(periodId) {
		let period = calendars.periodsById[periodId]
		let calendar = period.calendar
		let count = calendar.daysUntilNoteUpdatesLocked
		return i18n.countMessage('scorecards.notes.noPeriodNotesAllowed',
			count, period.label, count)
	},

	submit: function(e) {
		e.preventDefault()
		this.model.once('sync', this.trigger.bind(this, 'done'))
		var data = {
			text: this.$('textarea').val(),
			html: false
		}
		if (this.domainObject.section === 'scorecards') {
			data.periodId = this.periodDisplay.periodId
		}
		if (this.domainObject.section === 'initiatives') {
			data.appliesTo = this.dateDisplay.appliesTo
		}
		this.model.section = this.domainObject.section
		return this.model.save(data, {
			error: function(model, xhr) {
				this.formView.resetForm({ instadone: true })
				if (xhr.responseJSON.messageCode === 'integrity.scorecards.outsideLockPeriod') {
					this.formView.errorMessage(this.buildNotesLockedMessage(data.periodId))
					// set selector to "All Time", but don't disable
					this.periodDisplay.refresh()
				}

			}.bind(this)
		})
	},

	// delete an existing note
	'delete': function() {
		var confirmation = new DeleteConfirmation({
			description: i18n.get('common.note.note').toLowerCase()
		})
		appDisplay.dialog(confirmation)
		confirmation.once('confirm', function(group) {
			this.model.destroy()
			confirmation.trigger('done')
			// Note: sync event isn't fired on the model after destroy,
			// so let's just assume it worked
			this.trigger('done')
		}.bind(this))
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.periodDisplay, this.dateDisplay, this.tooltip,
			this.busyButton, this.formView, this.textareaField, this.textArea], 'remove')
	}

})

export default NoteForm
export { NotePeriodDisplay }

NoteForm.__filename__ = 'notes/note-form.js'
